module.exports = __webpack_public_path__ + "img/notary-journal_B09JRCW81D.9b9e080c.jpg";